export default __webpack_public_path__ + "static/media/kefir_bran.3a88a5f7.jpg";